import { create } from 'zustand';
import type { Brand } from '@/types/BrandOffer.types';

interface BrandOfferStoreState {
  brands: Brand[];
  brandsLoading: boolean;
  setBrands: (brands: Brand[]) => void;
  setBrandsLoading: (loading: boolean) => void;
}

const useBrandOfferStore = create<BrandOfferStoreState>((set) => ({
  brands: [],
  brandsLoading: false,
  setBrands: (brands) => set({ brands }),
  setBrandsLoading: (brandsLoading) => set({ brandsLoading }),
}));

export default useBrandOfferStore;
